'use strict';

/**
 * 
 */
module.controller('auditListCtrl',
        [ '$scope', '$rootScope', '$state', 'alertService', 'auditService', function($scope, $rootScope, $state, alertService, auditService) {

        	//------------------------------
        	
            $scope.loading = false;

            $scope.events = [];
            $scope.filter = {
                event: {},
                user: {},
                module: null
            };
            $scope.pagination = {
                current : 1,
                total : 0
            };
            $scope.audits = [];

            /**
             *
             * @param constantSelected
             */
            $scope.onConstantModuleChange = function(constantSelected){
                $scope.filter.event = {};

                var modules = MODULES.values();
                var events = [];
                for(var i = 0 ; i < modules.length ; i++){
                    if(constantSelected && constantSelected[0]){
                		if(constantSelected[0].enumName === modules[i].enumName ){
                			events = modules[i].events;
                        }                		
                	}
                }

                $scope.events = events;
            };

            /**
             * Función que se encarga de consultar los parámetros dado un número de página
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;
                page = page == undefined ? 1 : page;

                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;

            	if($scope.filter.user.selected){
            		filter.idUser = $scope.filter.user.selected.id;
            	}
                    

                if($scope.filter.detail){
                    filter.detail = $scope.filter.detail;
                }

                if($scope.filter.module && $scope.filter.module[0]){
                    filter.module = $scope.filter.module[0].enumName;
                }

                if($scope.filter.event.selected && $scope.filter.event.selected[0]){
                    filter.event = $scope.filter.event.selected[0].enumName;
                }

                if($scope.filter.initialDate){
                    filter.initialDate = moment($scope.filter.initialDate).format('DD-MM-YYYY');
                }
                
                if($scope.filter.finalDate){
                	filter.finalDate = moment($scope.filter.finalDate).format('DD-MM-YYYY');
                }

                auditService.searchAudits(filter).then(function(response) {
                    $scope.loading = false;

                    var result = response.getData();

                    $scope.audits = result.results;
                    $scope.pagination.total = result.totalRegisters;
                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.getEventName = function(module, event) {
                var constantModule = getConstantById(MODULES, module);

                if(constantModule){
                    var events = constantModule.events;
                    for(var i = 0 ; i < events.length ; i++){
                        if(events[i].enumName === event){
                            return events[i].name;
                        }
                    }
                }

                return '--';
            };

            /*TODO - andres romero - esta función podría pasarse a una global dado que se va a utilizar en varias partes*/
            $scope.convertToDate = function(date){
                var pos = date.indexOf('\[');
                var dateTxt = date.substring(0, pos);

                return new Date(dateTxt);
            };

            $scope.clearFilters = function() {
                $scope.filter = {
                    event: {},
                    user: {}
                };
                $scope.events = [];
            };

            /**
             * Por defecto consulta los parámetros de la primera página con los filtros por defecto
             */
            $scope.search(1);

        } ]);
